export { default } from './StarBadge'
